import React from "react";
import QRCode from "qrcode";

const QRCodeToCanvas = ({ value }: { value: string }) => {
  const canvasRef = React.useRef(null);

  React.useEffect(() => {
    QRCode.toCanvas(canvasRef.current, value).catch(() => null);
  }, [value]);

  return <canvas ref={canvasRef} />;
};

export { QRCodeToCanvas as QRCode };
